var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as tf from "@tensorflow/tfjs";
import { Buffer } from "buffer";
import { NSFW_CLASSES } from "./nsfw_classes.js";
var IMAGE_SIZE = 224;
var getGlobal = function () {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof global !== "undefined")
        return global;
    if (typeof window !== "undefined")
        return window;
    if (typeof self !== "undefined")
        return self;
    throw new Error("Unable to locate global object");
};
function getModelConfig(models) {
    var config = {};
    models.forEach(function (model) {
        config[model.name] = model;
    });
    return config;
}
function isModelName(name) {
    return name === "MobileNetV2" ||
        name === "MobileNetV2Mid" ||
        name === "InceptionV3";
}
var getModelJson = function (modelName, availableModels) { return __awaiter(void 0, void 0, void 0, function () {
    var globalModel, model;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                globalModel = getGlobal().model;
                if (globalModel) {
                    return [2, globalModel];
                }
                model = availableModels[modelName];
                if (!model) {
                    throw new Error("Model '".concat(modelName, "' was not found in the provided models registry."));
                }
                return [4, model.modelJson()];
            case 1: return [2, (_a.sent()).default];
        }
    });
}); };
var getWeightData = function (modelName, availableModels) { return __awaiter(void 0, void 0, void 0, function () {
    var model, numOfWeightBundles, weightBundles, bundles, i, bundleName, identifier, globalWeight, weightBundle, weight;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                model = availableModels[modelName];
                if (!model) {
                    throw new Error("Model '".concat(modelName, "' was not found in the provided models registry."));
                }
                numOfWeightBundles = model.numOfWeightBundles, weightBundles = model.weightBundles;
                bundles = [];
                i = 0;
                _c.label = 1;
            case 1:
                if (!(i < numOfWeightBundles)) return [3, 5];
                bundleName = "group1-shard".concat(i + 1, "of").concat(numOfWeightBundles);
                identifier = bundleName.replace(/-/g, "_");
                globalWeight = getGlobal()[identifier];
                if (!globalWeight) return [3, 2];
                bundles.push((_a = {}, _a[bundleName] = globalWeight, _a));
                return [3, 4];
            case 2:
                weightBundle = weightBundles[i];
                if (!weightBundle) {
                    throw new Error("Could not find a weight bundle loader for '".concat(modelName, "' at index ").concat(i, "."));
                }
                return [4, weightBundle()];
            case 3:
                weight = (_c.sent()).default;
                bundles.push((_b = {}, _b[bundleName] = weight, _b));
                _c.label = 4;
            case 4:
                i++;
                return [3, 1];
            case 5: return [2, Object.assign.apply(Object, __spreadArray([{}], bundles, false))];
        }
    });
}); };
function loadWeights(modelName, availableModels) {
    return __awaiter(this, void 0, void 0, function () {
        var weightDataBundles, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, getWeightData(modelName, availableModels)];
                case 1:
                    weightDataBundles = _a.sent();
                    return [2, weightDataBundles];
                case 2:
                    error_1 = _a.sent();
                    if (error_1 instanceof Error && /provided models registry/.test(error_1.message)) {
                        throw error_1;
                    }
                    throw new Error("Could not load the weight data. Make sure you are importing the correct shard files from the models directory. Ref: https://github.com/infinitered/nsfwjs?tab=readme-ov-file#browserify");
                case 3: return [2];
            }
        });
    });
}
function loadModel(modelName, availableModels) {
    return __awaiter(this, void 0, void 0, function () {
        var modelJson, weightData, handler, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isModelName(modelName))
                        return [2, modelName];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4, getModelJson(modelName, availableModels)];
                case 2:
                    modelJson = _a.sent();
                    return [4, loadWeights(modelName, availableModels)];
                case 3:
                    weightData = _a.sent();
                    handler = new JSONHandler(modelJson, weightData);
                    return [2, handler];
                case 4:
                    error_2 = _a.sent();
                    if (error_2 instanceof Error && /provided models registry/.test(error_2.message)) {
                        throw error_2;
                    }
                    throw new Error("Could not load the model. Make sure you are importing the model.min.js bundle. Ref: https://github.com/infinitered/nsfwjs?tab=readme-ov-file#browserify");
                case 5: return [2];
            }
        });
    });
}
export function load(modelOrUrl_1) {
    return __awaiter(this, arguments, void 0, function (modelOrUrl, options) {
        var availableModels, model, modelUrlOrHandler, nsfwnet;
        if (options === void 0) { options = { size: IMAGE_SIZE }; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (tf == null) {
                        throw new Error("Cannot find TensorFlow.js. If you are using a <script> tag, please " +
                            "also include @tensorflow/tfjs on the page before using this model.");
                    }
                    availableModels = getModelConfig(options.modelDefinitions || []);
                    if (isModelName(modelOrUrl)) {
                        console.info("%cYou're using the model: '".concat(modelOrUrl, "'. See NSFWJS docs for instructions on hosting your own model (https://github.com/infinitered/nsfwjs?tab=readme-ov-file#host-your-own-model)."), "color: lightblue");
                        model = availableModels[modelOrUrl];
                        if (model === null || model === void 0 ? void 0 : model.options) {
                            options = __assign(__assign({}, options), model.options);
                        }
                    }
                    options.size = (options === null || options === void 0 ? void 0 : options.size) || IMAGE_SIZE;
                    return [4, loadModel(modelOrUrl, availableModels)];
                case 1:
                    modelUrlOrHandler = _a.sent();
                    nsfwnet = new NSFWJS(modelUrlOrHandler, options);
                    return [4, nsfwnet.load()];
                case 2:
                    _a.sent();
                    return [2, nsfwnet];
            }
        });
    });
}
var JSONHandler = (function () {
    function JSONHandler(modelJson, weightDataBase64) {
        this.modelJson = modelJson;
        this.weightDataBase64 = weightDataBase64;
    }
    JSONHandler.prototype.arrayBufferFromBase64 = function (base64) {
        var binaryString = Buffer.from(base64, "base64").toString("binary");
        var len = binaryString.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    };
    JSONHandler.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modelArtifacts, weightSpecs, weightData, _i, _a, group, _b, _c, path, base64, buffer, weightDataConcat, offset, i;
            return __generator(this, function (_d) {
                modelArtifacts = {
                    modelTopology: this.modelJson.modelTopology,
                    format: this.modelJson.format,
                    generatedBy: this.modelJson.generatedBy,
                    convertedBy: this.modelJson.convertedBy,
                };
                if (this.modelJson.weightsManifest != null) {
                    weightSpecs = [];
                    weightData = [];
                    for (_i = 0, _a = this.modelJson.weightsManifest; _i < _a.length; _i++) {
                        group = _a[_i];
                        for (_b = 0, _c = group.paths; _b < _c.length; _b++) {
                            path = _c[_b];
                            base64 = this.weightDataBase64[path];
                            if (!base64) {
                                throw new Error("Could not find the weight data. Make sure you are importing the correct weight bundle for the model: ".concat(path, ".min.js."));
                            }
                            buffer = this.arrayBufferFromBase64(base64);
                            weightData.push(new Uint8Array(buffer));
                        }
                        weightSpecs.push.apply(weightSpecs, group.weights);
                    }
                    modelArtifacts.weightSpecs = weightSpecs;
                    weightDataConcat = new Uint8Array(weightData.reduce(function (a, b) { return a + b.length; }, 0));
                    offset = 0;
                    for (i = 0; i < weightData.length; i++) {
                        weightDataConcat.set(weightData[i], offset);
                        offset += weightData[i].byteLength;
                    }
                    modelArtifacts.weightData = weightDataConcat.buffer;
                }
                if (this.modelJson.trainingConfig != null) {
                    modelArtifacts.trainingConfig = this.modelJson.trainingConfig;
                }
                if (this.modelJson.userDefinedMetadata != null) {
                    modelArtifacts.userDefinedMetadata = this.modelJson.userDefinedMetadata;
                }
                return [2, modelArtifacts];
            });
        });
    };
    return JSONHandler;
}());
var NSFWJS = (function () {
    function NSFWJS(modelUrlOrIOHandler, options) {
        this.endpoints = [];
        this.intermediateModels = {};
        this.disposed = false;
        this.options = options;
        this.normalizationOffset = tf.scalar(255);
        this.urlOrIOHandler = modelUrlOrIOHandler;
        if (typeof modelUrlOrIOHandler === "string" &&
            !modelUrlOrIOHandler.startsWith("indexeddb://") &&
            !modelUrlOrIOHandler.startsWith("localstorage://") &&
            !modelUrlOrIOHandler.endsWith("model.json")) {
            this.urlOrIOHandler = "".concat(modelUrlOrIOHandler, "model.json");
        }
        else {
            this.urlOrIOHandler = modelUrlOrIOHandler;
        }
    }
    NSFWJS.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, size, type, _b, _c, result;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.disposed) {
                            throw new Error("This NSFWJS instance has been disposed.");
                        }
                        _a = this.options, size = _a.size, type = _a.type;
                        if (!(type === "graph")) return [3, 2];
                        _b = this;
                        return [4, tf.loadGraphModel(this.urlOrIOHandler)];
                    case 1:
                        _b.model = _d.sent();
                        return [3, 4];
                    case 2:
                        _c = this;
                        return [4, tf.loadLayersModel(this.urlOrIOHandler)];
                    case 3:
                        _c.model = _d.sent();
                        this.endpoints = this.model.layers.map(function (l) { return l.name; });
                        _d.label = 4;
                    case 4:
                        result = tf.tidy(function () {
                            return _this.model.predict(tf.zeros([1, size, size, 3]));
                        });
                        return [4, result.data()];
                    case 5:
                        _d.sent();
                        result.dispose();
                        return [2];
                }
            });
        });
    };
    NSFWJS.prototype.infer = function (img, endpoint) {
        var _this = this;
        if (this.disposed) {
            throw new Error("This NSFWJS instance has been disposed.");
        }
        if (endpoint != null && this.endpoints.indexOf(endpoint) === -1) {
            throw new Error("Unknown endpoint ".concat(endpoint, ". Available endpoints: ").concat(this.endpoints, "."));
        }
        return tf.tidy(function () {
            if (!(img instanceof tf.Tensor)) {
                img = tf.browser.fromPixels(img);
            }
            var normalized = img
                .toFloat()
                .div(_this.normalizationOffset);
            var resized = normalized;
            var size = _this.options.size;
            if (img.shape[0] !== size || img.shape[1] !== size) {
                var alignCorners = true;
                resized = tf.image.resizeBilinear(normalized, [size, size], alignCorners);
            }
            var batched = resized.reshape([1, size, size, 3]);
            var model;
            if (endpoint == null) {
                model = _this.model;
            }
            else {
                if (_this.model.hasOwnProperty("layers") &&
                    _this.intermediateModels[endpoint] == null) {
                    var layer = _this.model.layers.find(function (l) { return l.name === endpoint; });
                    _this.intermediateModels[endpoint] = tf.model({
                        inputs: _this.model.inputs,
                        outputs: layer.output,
                    });
                }
                model = _this.intermediateModels[endpoint];
            }
            return model.predict(batched);
        });
    };
    NSFWJS.prototype.classify = function (img_1) {
        return __awaiter(this, arguments, void 0, function (img, topk) {
            var logits, classes;
            if (topk === void 0) { topk = 5; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.disposed) {
                            throw new Error("This NSFWJS instance has been disposed.");
                        }
                        logits = this.infer(img);
                        return [4, getTopKClasses(logits, topk)];
                    case 1:
                        classes = _a.sent();
                        logits.dispose();
                        return [2, classes];
                }
            });
        });
    };
    NSFWJS.prototype.dispose = function () {
        if (this.disposed) {
            return;
        }
        Object.values(this.intermediateModels).forEach(function (intermediateModel) {
            intermediateModel.dispose();
        });
        this.intermediateModels = {};
        if (this.model) {
            this.model.dispose();
        }
        this.normalizationOffset.dispose();
        this.disposed = true;
    };
    return NSFWJS;
}());
export { NSFWJS };
function getTopKClasses(logits, topK) {
    return __awaiter(this, void 0, void 0, function () {
        var values, valuesAndIndices, i, topkValues, topkIndices, i, topClassesAndProbs, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, logits.data()];
                case 1:
                    values = _a.sent();
                    valuesAndIndices = [];
                    for (i = 0; i < values.length; i++) {
                        valuesAndIndices.push({ value: values[i], index: i });
                    }
                    valuesAndIndices.sort(function (a, b) {
                        return b.value - a.value;
                    });
                    topkValues = new Float32Array(topK);
                    topkIndices = new Int32Array(topK);
                    for (i = 0; i < topK; i++) {
                        topkValues[i] = valuesAndIndices[i].value;
                        topkIndices[i] = valuesAndIndices[i].index;
                    }
                    topClassesAndProbs = [];
                    for (i = 0; i < topkIndices.length; i++) {
                        topClassesAndProbs.push({
                            className: NSFW_CLASSES[topkIndices[i]],
                            probability: topkValues[i],
                        });
                    }
                    return [2, topClassesAndProbs];
            }
        });
    });
}
//# sourceMappingURL=core.js.map